import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppServices } from './../../app.services';
import { NotifyService } from './../../addon/notify.service';
import { FirebaseService } from './../../addon/firebase.service';

@Component({
	selector: 'app-mymessages',
	templateUrl: './mymessages.component.html',
	styleUrls: ['./mymessages.component.css']
})
export class MymessagesComponent implements OnInit {
	data_member; search; friend; friends = []; messages = []; sendtype = 'direct';
	pre_converse;
	constructor(private router: Router, private appServices: AppServices, private notifyService: NotifyService, private firebaseService: FirebaseService) { }

	ngOnInit() {
		if(this.appServices.session[0]) {
			let code = this.appServices.session[0].member.code;
			this.appServices.api('Members/find', {
				'filter': `{"where":{"code": "${code}"}}`
			}, this).then(function(obj){
				let res = obj.response.json().res;
				obj.component.data_member = res[0];
				obj.component.appServices.api('Members/find', {
					'filter': `{"where":{"code":{"neq":"${code}"}, "accountcode": "${obj.component.appServices.session[0].member.accountcode}", "deleted": false}}`
				}, obj.component).then(function(obj){
					let res = obj.response.json().res;
					if(res.length > 0) {
						obj.component.friends = res;
					}
				}).catch(function(err){
					err.component.notifyService.show(err.err.json().error.message, 'danger');
				})
				obj.component.firebaseService.getToken((token) => {
					obj.component.appServices.api('Members/save', {
						'code': obj.component.data_member.code,
						'fcm': token
					}, obj.component).then(function(obj){
						let res = obj.response.json().res;
						obj.component.notifyService.show('Chat Initialize');
					}).catch(function(err){
						err.component.notifyService.show(err.err.json().error.message, 'danger');
					});
				})
			}).catch(function(err){
				err.component.notifyService.show(err.err.json().error.message, 'danger');
			});
			
			this.firebaseService.getMessage((payload) => {
				this.appServices.api_ai('Bots/find', {
					'filter': `{"where":{"code":"${this.pre_converse}"}}`
				}, this).then((obj) => {
					let res = obj.response.json().res;
					if(res.length > 0) {
						this.appServices.api_ai('Bots/save', {
							'codebot': res[0].codebot,
							'dialog': res[0].dialog,
							'response': payload.data.body,
							'mark': res[0].mark,
							'deleted': res[0].deleted
						}, this).then((obj) => {
							let res = obj.response.json().res;
							if(res.speak) {
								obj.component.pre_converse = res.code;
							}
						}).catch(function(err){
							err.component.notifyServices.show(err.err.json().error.message, 'danger');
						})
					}
				}).catch(function(err){
					err.component.notifyServices.show(err.err.json().error.message, 'danger');
				})
				this.messages.push(payload);
			});
		} else {
			this.router.navigate(['main/home']);
		}
	}
	searchFriend(data) {
		this.appServices.api('Members/find', {
			'filter': `{"where":{"name":{"ilike":"${data}"}, "code":{"neq":"${this.appServices.session[0].member.code}"}, "accountcode": "${this.appServices.session[0].member.accountcode}", "deleted": false}}`
		}, this).then(function(obj){
			let res = obj.response.json().res;
			if(res.length > 0) {
				obj.component.friends = res;
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	doChoose(data) {
		if(data.fcm) {
			this.friend = data;
			let existfr = this.friends.find((el) => {
				if(el.fcm == data.fcm) return el;
			});
			if(!existfr) {
				this.friends = this.friends.concat([data]);
			}
			this.messages = [];
		} else {
			this.notifyService.show('Tell your friend join Messages', 'danger');
		}
	}
	doSend(data, sendtype) {
		this.sendtype = sendtype;
		this.appServices.api_ai('Bots/ask', {
			'message': `{"cmd":"${data.msg}","codeconversation":"${this.pre_converse}"}`,
			'account': this.appServices.session[0].member.code,
			'token': 'NO-RESPONSE',
			'host':''
		}, this).then((obj) => {
			let res = obj.response.json().res;
			if(res.speak) {
				obj.component.pre_converse = res.code;
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
		this.messages.push({
			'data': {
				'title': 'me',
				'body': data.msg,
				'dt': new Date().toISOString()
			}
		});
		if(sendtype == 'broadcast') {
			this.friends.forEach((friend, index, arr) => {
				this.appServices.api('Members/find', {
					'filter': `{"where":{"code": "${friend.code}"}}`
				}, this).then(function(obj){
					let res = obj.response.json().res;
					if(res.length > 0) {
						obj.component.appServices.api('Pushes/notification', {
							'token': res[0].fcm,
							'title': obj.component.data_member.name,
							'message': data.msg,
							'data': JSON.stringify({
								'codemember': obj.component.data_member.code
							})
						}, obj.component).then(function(obj){
							let res = obj.response.json().res;
							let fcm = JSON.parse(res);
							if(fcm.failure) {
								obj.component.notifyService.show(fcm.results[0].error, 'danger');
							}
						}).catch(function(err){
							err.component.notifyService.show(err.err.json().error.message, 'danger');
						});
					} else {
						obj.component.notifyService.show('Error');
					}
				}).catch(function(err){
					err.component.notifyService.show(err.err.json().error.message, 'danger');
				});
			})
		} else if(sendtype == 'direct') {
			this.appServices.api('Members/find', {
				'filter': `{"where":{"code": "${this.friend.code}"}}`
			}, this).then(function(obj){
				let res = obj.response.json().res;
				if(res.length > 0) {
					obj.component.appServices.api('Pushes/notification', {
						'token': res[0].fcm,
						'title': obj.component.data_member.name,
						'message': data.msg,
						'data': JSON.stringify({
							'codemember': obj.component.data_member.code
						})
					}, obj.component).then(function(obj){
						let res = obj.response.json().res;
						let fcm = JSON.parse(res);
						if(fcm.failure) {
							obj.component.notifyService.show(fcm.results[0].error, 'danger');
						}
					}).catch(function(err){
						err.component.notifyService.show(err.err.json().error.message, 'danger');
					});
				} else {
					obj.component.notifyService.show('Error');
				}
			}).catch(function(err){
				err.component.notifyService.show(err.err.json().error.message, 'danger');
			});
		}
	}
}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/main/mymessages/mymessages.component.ts